import { __decorate, __metadata } from "tslib";
import { Field } from '@cbbt/lib-interface';
import { TaxResidenceType } from '../enums/TaxResidenceType.js';
import { IndividualAddressesWithId } from './addresses/IndividualAddressWithId.js';
import { GetIndividualByIdRequest } from './GetIndividualByIdRequest.js';
import { KYCResultResponse } from './identity-verification/KYCResultResponse.js';
import { IndividualPersonalDetails } from './IndividualPersonalDetails.js';
import { NationalityResponse, TaxResidentCountriesResponse, } from './nationality-taxresident/NationalityAndTaxResidentResponse.js';
import { IndividualOtherName } from './other-names/IndividualOtherName.js';
import { ProductFeatureResponse } from './productFeatures/ProductFeatureResponse.js';
export class GetIndividualByIdResponse extends GetIndividualByIdRequest {
    personalDetails;
    otherNames;
    addresses;
    nationalities;
    taxResidence;
    taxResidentCountries;
    identityVerificationSkipped;
    identityVerificationSkippedReason;
    identityVerificationGuid;
    identityVerificationJourneyReferenceId;
    identityVerificationRetryCount;
    confirmTaxResidency;
    isDualNationality;
    kycResult;
    productFeatures;
}
__decorate([
    Field.message({
        required: false,
        description: 'Personal Details of an Individual',
    }),
    __metadata("design:type", IndividualPersonalDetails)
], GetIndividualByIdResponse.prototype, "personalDetails", void 0);
__decorate([
    Field.array({
        required: false,
        items: {
            type: 'message',
            message: IndividualOtherName,
        },
    }),
    __metadata("design:type", Array)
], GetIndividualByIdResponse.prototype, "otherNames", void 0);
__decorate([
    Field.array({
        required: false,
        items: {
            type: 'message',
            message: IndividualAddressesWithId,
        },
    }),
    __metadata("design:type", Array)
], GetIndividualByIdResponse.prototype, "addresses", void 0);
__decorate([
    Field.array({
        required: false,
        items: {
            type: 'message',
            message: NationalityResponse,
        },
    }),
    __metadata("design:type", Array)
], GetIndividualByIdResponse.prototype, "nationalities", void 0);
__decorate([
    Field.enum({
        enum: TaxResidenceType,
        description: 'Tax Residencies',
    }),
    __metadata("design:type", String)
], GetIndividualByIdResponse.prototype, "taxResidence", void 0);
__decorate([
    Field.array({
        required: false,
        items: {
            type: 'message',
            message: TaxResidentCountriesResponse,
        },
    }),
    __metadata("design:type", Array)
], GetIndividualByIdResponse.prototype, "taxResidentCountries", void 0);
__decorate([
    Field.boolean({
        description: 'Skipped',
        required: false,
    }),
    __metadata("design:type", Boolean)
], GetIndividualByIdResponse.prototype, "identityVerificationSkipped", void 0);
__decorate([
    Field.string({
        description: 'Skipped Reason',
        required: false,
    }),
    __metadata("design:type", String)
], GetIndividualByIdResponse.prototype, "identityVerificationSkippedReason", void 0);
__decorate([
    Field.string({
        description: 'Guid',
        required: false,
    }),
    __metadata("design:type", String)
], GetIndividualByIdResponse.prototype, "identityVerificationGuid", void 0);
__decorate([
    Field.string({
        description: 'Journey Reference Id',
        required: false,
    }),
    __metadata("design:type", String)
], GetIndividualByIdResponse.prototype, "identityVerificationJourneyReferenceId", void 0);
__decorate([
    Field.number({
        description: 'IDV Retry Count',
        numberType: 'integer',
        required: false,
    }),
    __metadata("design:type", Number)
], GetIndividualByIdResponse.prototype, "identityVerificationRetryCount", void 0);
__decorate([
    Field.boolean({
        description: 'Confirm Tax residency',
    }),
    __metadata("design:type", Boolean)
], GetIndividualByIdResponse.prototype, "confirmTaxResidency", void 0);
__decorate([
    Field.boolean({
        description: 'dual nationality flag',
        required: false,
    }),
    __metadata("design:type", Boolean)
], GetIndividualByIdResponse.prototype, "isDualNationality", void 0);
__decorate([
    Field.array({
        required: false,
        items: {
            type: 'message',
            message: KYCResultResponse,
        },
    }),
    __metadata("design:type", Array)
], GetIndividualByIdResponse.prototype, "kycResult", void 0);
__decorate([
    Field.array({
        required: false,
        items: {
            type: 'message',
            message: ProductFeatureResponse,
        },
    }),
    __metadata("design:type", Array)
], GetIndividualByIdResponse.prototype, "productFeatures", void 0);
//# sourceMappingURL=GetIndividualByIdResponse.js.map